import { useQuery } from "@tanstack/react-query";
import { usePageSettings } from "../contexts/PageSettingsContext";
import { useCheckout } from "../contexts/CheckoutPageContext";
import axios from "axios";

export const useFetchSingleAddonPrice = ({ addonId, paymentCycle = "monthly" }) => {
	const { currency } = usePageSettings();
	const { orderCount } = useCheckout();

	const fetchPriceWithAddon = async () => {
		if (!addonId) return null; // Return null if no addon ID is provided

		const endpoint = `${process.env.GATSBY_PRICE_ENDPOINT}?currency=${currency}&cycle=${paymentCycle}&count=${orderCount}`;
		const payload = { addons: [addonId] };

		try {
			const response = await axios.post(endpoint, payload, {
				headers: { "Content-Type": "application/json" },
			});
			return response.data.price;
		} catch (error) {
			throw new Error(`Failed to fetch addon price: ${error.message}`);
		}
	};

	return useQuery({
		queryKey: ["singleAddonPrice", currency, addonId, paymentCycle, orderCount],
		queryFn: fetchPriceWithAddon,
		refetchOnWindowFocus: false,
		enabled: !!addonId, // Only run query if an addonId is provided
	});
};
